import { useEffect, useRef, useState } from "react";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";
import { api, errorMessage } from "../api";

export function LogoUpload() {
  const [src, setSrc] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const input = useRef(null);
  const load = () => api.get("/outlet/logo", { responseType: "blob" }).then(({ data }) => setSrc((old) => { if (old) URL.revokeObjectURL(old); return URL.createObjectURL(data); })).catch(() => setSrc(""));
  useEffect(() => { load(); }, []);
  const run = async (fn) => { setBusy(true); setErr(""); try { await fn(); } catch (e) { setErr(errorMessage(e)); } finally { setBusy(false); } };
  const upload = (file) => file && run(async () => { const fd = new FormData(); fd.append("file", file); await api.post("/outlet/logo", fd); await load(); });
  return (
    <div className="logo-upload" data-testid="logo-upload">
      <div className="logo-box">{src ? <img src={src} alt="Letterhead logo" data-testid="logo-preview" /> : <ImagePlus size={20} />}</div>
      <div>
        <small>Letterhead logo · PNG/JPG/WEBP under 2 MB · printed on A4 invoices</small>
        <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
          <button type="button" className="secondary-button" disabled={busy} onClick={() => input.current?.click()} data-testid="logo-upload-button">{busy ? <Loader2 className="spin" size={14} /> : <ImagePlus size={14} />} {src ? "Replace logo" : "Upload logo"}</button>
          {src && <button type="button" className="secondary-button" disabled={busy} onClick={() => run(async () => { await api.delete("/outlet/logo"); setSrc(""); })} data-testid="logo-remove-button"><Trash2 size={14} /> Remove</button>}
        </div>
        {err && <div className="auth-alert error" data-testid="logo-error">{err}</div>}
      </div>
      <input ref={input} type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid="logo-file-input" />
    </div>
  );
}
